/* EMP LAB — máscara dinâmica CPF/CNPJ (somente dígitos). */
(function () {
  'use strict';
  function attach(typeId, fieldId, labelId) {
    var type = document.getElementById(typeId);
    var input = document.getElementById(fieldId);
    var label = document.getElementById(labelId);
    if (!type || !input || !label || input.dataset.emplabMaskReady === '1') return;
    input.dataset.emplabMaskReady = '1';
    input.type = 'text';
    input.inputMode = 'numeric';
    input.autocomplete = 'off';
    input.pattern = '[0-9.\\/-]*';
    function isPJ() { return type.value === 'Pessoa jurídica'; }
    function digits(value) { return String(value || '').replace(/\D/g, ''); }
    function mask(value) {
      var pj = isPJ(), d = digits(value).slice(0, pj ? 14 : 11);
      if (pj) {
        return d.replace(/^(\d{2})(\d)/, '$1.$2')
          .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
          .replace(/\.(\d{3})(\d)/, '.$1/$2')
          .replace(/(\/\d{4})(\d)/, '$1-$2');
      }
      return d.replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1-$2');
    }
    function check() {
      var count = digits(input.value).length, expected = isPJ() ? 14 : 11;
      input.setCustomValidity(count && count !== expected ? 'Digite ' + (isPJ() ? 'os 14 números do CNPJ.' : 'os 11 números do CPF.') : '');
    }
    function sync(reset) {
      var pj = isPJ();
      label.textContent = pj ? 'CNPJ' : 'CPF';
      input.name = pj ? 'contact[CNPJ]' : 'contact[CPF]';
      input.placeholder = pj ? '00.000.000/0000-00' : '000.000.000-00';
      input.maxLength = pj ? 18 : 14;
      input.setAttribute('aria-label', pj ? 'CNPJ' : 'CPF');
      input.value = reset ? '' : mask(input.value);
      check();
    }
    input.addEventListener('input', function () {
      var wasAtEnd = input.selectionStart === input.value.length;
      input.value = mask(input.value);
      if (wasAtEnd) input.setSelectionRange(input.value.length, input.value.length);
      check();
    });
    input.addEventListener('blur', check);
    input.addEventListener('paste', function () { setTimeout(function () { input.value = mask(input.value); check(); }, 0); });
    type.addEventListener('change', function () { sync(true); });
    sync(false);
  }
  function attachCEP() {
    var input = document.getElementById('emplab-cep');
    if (!input || input.dataset.emplabCepReady === '1') return;
    input.dataset.emplabCepReady = '1';
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('maxlength', '9');
    function format(raw) {
      var d = String(raw || '').replace(/\D/g, '').slice(0, 8);
      return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
    }
    function validate() {
      var len = input.value.replace(/\D/g, '').length;
      input.setCustomValidity(len !== 8 ? 'Informe os 8 números do CEP.' : '');
    }
    input.addEventListener('input', function () {
      input.value = format(input.value);
      validate();
    });
    input.addEventListener('blur', validate);
    input.addEventListener('paste', function () {
      setTimeout(function () { input.value = format(input.value); validate(); }, 0);
    });
    input.value = format(input.value);
    // Deixe a validação nativa 'required' cuidar do campo vazio antes da digitação.
  }
  function init() {
    attachCEP();
    attach('emplab-type', 'emplab-document', 'emplab-document-label');
    attach('emplab-product-customer-type', 'emplab-product-document', 'emplab-product-document-label');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
